var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExportImage = function SvgExportImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    id: "export-image_svg__Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".export-image_svg__cls-1{fill:none;stroke:#292d32;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "export-image_svg__gallery-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "export-image_svg__Vector",
    className: "export-image_svg__cls-1",
    d: "M19 16c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "export-image_svg__Vector-2",
    className: "export-image_svg__cls-1",
    d: "M21 10h-4c-5 0-7 2-7 7v6c0 5 2 7 7 7h6c5 0 7-2 7-7v-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "export-image_svg__Vector-3",
    className: "export-image_svg__cls-1",
    d: "m10.67 26.95 4.93-3.31c.82-.53 1.88-.47 2.64.14l.33.29c.82.67 2 .67 2.82 0l4.16-3.57c.82-.67 2-.67 2.82 0L30 21.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "export-image_svg__Vector-5",
    className: "export-image_svg__cls-1",
    d: "m28 15 2-2-2-2 2 2h-6"
  }))));
};
export default SvgExportImage;